import { render, staticRenderFns } from "./ListOrderPurchase.vue?vue&type=template&id=bf2c79d0&scoped=true"
import script from "./ListOrderPurchase.vue?vue&type=script&lang=js"
export * from "./ListOrderPurchase.vue?vue&type=script&lang=js"
import style0 from "./ListOrderPurchase.vue?vue&type=style&index=0&id=bf2c79d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2c79d0",
  null
  
)

export default component.exports